/** @module application */

import $ from 'jquery';
import { liveEvents } from '../../../../assets/js/application';

/**
 * Should not be referenced directly.
 *
 * @param {NodeList} filters
 *
 * @private
 * @see {@link filters}
 */
export async function initFilters(filters) {
    const events = await liveEvents();

    filters.forEach((filter) => {
        const inputs = filter.querySelectorAll('input[type="checkbox"]'),
            targets = document.querySelectorAll(
                filter.dataset.filter
                    .split(',')
                    .map((f) => `[data-filter-target='${f}']`)
                    .join(','),
            ),
            itemSelector = filter.dataset.item || '[data-filter-item]',
            logic = filter.dataset.logic || 'OR',
            // clearFilterWrapper = filter.closest('.js-clear-filter-wrapper'),
            filterChangedEvent = new CustomEvent('filter.changed', { bubbles: true, cancelable: false }),
            itemsFilteredEvent = new CustomEvent('filter.filtered', { bubbles: true, cancelable: false }),
            cachedItems = new WeakMap(),
            preFilteredItems = new WeakMap();

        function onInputChange(event) {
            if (event) {
                event.target.closest('.filter__term').classList.toggle('is-checked', Boolean(event.target.checked));
            }

            // show/hide the corresponding items
            // note: requestAnimationFrame is important to ensure that hierarchical inputs are done with their updates
            requestAnimationFrame(() => {
                let checkedTerms = Array.prototype.map.call(
                    filter.querySelectorAll('input:checked') || [],
                    ({ value }) => value,
                );

                targets.forEach((target) => {
                    let items = [];

                    if (preFilteredItems.has(target)) {
                        items = preFilteredItems.get(target);
                    }

                    if (items.length === 0) {
                        if (cachedItems.has(target) === false) {
                            cachedItems.set(target, target.querySelectorAll(`${itemSelector}:not(.filter)`));
                        }

                        items = cachedItems.get(target);
                    }

                    items.forEach((item) => {
                        let show = true,
                            terms = JSON.parse(item.dataset.filterItem || '[]');

                        if (checkedTerms.length) {
                            if (logic === 'OR') {
                                show = checkedTerms.some((term) => terms.includes(term));
                            } else if (logic === 'AND') {
                                show = checkedTerms.every((term) => terms.includes(term));
                            }
                        }

                        item.hidden = !show;
                    });

                    // inform dependent components that the filtered items changed
                    target.dispatchEvent(itemsFilteredEvent);
                });
            });
        }

        inputs.forEach((input) => {
            input.closest('.filter__term').classList.toggle('is-checked', Boolean(input.checked));
            input.addEventListener('change', onInputChange);
        });

        onInputChange();

        /* TODO implement once vertical filter is defined
        // reset filter values
        if (clearFilterWrapper) {
            clearFilterWrapper.querySelectorAll('.js-clear-filter').forEach((clearFilterButton) => {
                clearFilterButton.addEventListener('click', () => {
                    inputs.forEach((input) => {
                        input.checked = false;
                        input.indeterminate = false;
                    });

                    onInputChange();
                });
            });
        }
        */

        // inform dependent components that the filter component changed the layout.
        // unfortunately, it is not possible to listen for jQuery events in vanilla JS
        $(filter).on('down.zf.accordionMenu', () => {
            targets.forEach((target) => {
                target.dispatchEvent(filterChangedEvent);
            });
        });

        events.addEventListener(document, 'filter.searched', (event) => {
            if (event.target.dataset.search === filter.dataset.filter) {
                let checkedInputs = [];

                preFilteredItems.set(event.detail.target, event.detail.results);

                inputs.forEach((input) => {
                    if (input.checked) {
                        checkedInputs.push(input);
                    }

                    input.checked = false;
                });
            }
        });
    });
}
